import { render, staticRenderFns } from "./FormExpense.vue?vue&type=template&id=5a64d789&"
import script from "./FormExpense.vue?vue&type=script&lang=js&"
export * from "./FormExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports